var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8264 18.6159C16.7337 17.4576 19.7729 12.5405 18.6147 7.63322C17.4564 2.72592 12.5394 -0.313313 7.63205 0.844917C2.72474 2.00315 -0.314487 6.92024 0.843743 11.8275C2.00197 16.7349 6.91906 19.7741 11.8264 18.6159Z",
    stroke: "#6B727C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97217 20.4264C12.7448 20.4264 15.404 19.3249 17.3645 17.3644C19.3251 15.4038 20.4266 12.7447 20.4266 9.97198",
    stroke: "#6B727C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1683 16.4616L23.0403 21.3384C23.1524 21.4499 23.2414 21.5825 23.3021 21.7285C23.3628 21.8745 23.3941 22.0311 23.3941 22.1892C23.3941 22.3473 23.3628 22.5039 23.3021 22.6499C23.2414 22.7959 23.1524 22.9285 23.0403 23.04V23.04C22.9287 23.1532 22.7957 23.2431 22.649 23.3044C22.5023 23.3658 22.3449 23.3974 22.1859 23.3974C22.0269 23.3974 21.8695 23.3658 21.7228 23.3044C21.5762 23.2431 21.4432 23.1532 21.3315 23.04L16.4619 18.168",
    stroke: "#6B727C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2e72c10f.svg";
export { ForwardRef as ReactComponent };